import React, { useEffect, useState } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import { Add } from '@material-ui/icons';
import ImagePicker from '../../../../shared/ui-builder/image-picker/Image-Picker';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import { BUTTON_W_ICON } from '../../../../constants/UiBuilderConst';

const ButtonWithIcon = (props) => {
  const { onItemChange, config, handleError, componentNdx, groupId } = props;
  const initialButtons = [
    {
      buttonTitle: '',
      leftIconImgURL: '',
      rightIconImgURL: '',
      leftIconHide: false,
      rightIconHide: false,
      redirectLink: [
        {
          connection: '',
          linkId: '',
          isActive: true,
        },
      ],
    },
    {
      buttonTitle: '',
      leftIconImgURL: '',
      rightIconImgURL: '',
      leftIconHide: false,
      rightIconHide: false,
      redirectLink: [
        {
          connection: '',
          linkId: '',
          isActive: true,
        },
      ],
    },
    {
      buttonTitle: '',
      leftIconImgURL: '',
      rightIconImgURL: '',
      leftIconHide: false,
      rightIconHide: false,
      redirectLink: [
        {
          connection: '',
          linkId: '',
          isActive: true,
        },
      ],
    },
  ];

  const addNewButton = {
    buttonTitle: '',
    leftIconImgURL: '',
    rightIconImgURL: '',
    leftIconHide: false,
    rightIconHide: false,
    redirectLink: [
      {
        connection: '',
        linkId: '',
        isActive: true,
      },
    ],
  };

  const [h2Title, setH2Title] = useState(config?.titleH2 || '');
  const [backgroundColor, setBackgroundColor] = useState(
    config.backgroundColor ? config.backgroundColor : '#ffffff',
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [slidesList, setSlidesList] = useState(
    config.button && config.button.length ? config.button : initialButtons,
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabContent, setActiveTabContent] = useState(slidesList[0]);
  const [error, setError] = useState(null);

  const maxSlidesCount = 20;

  useEffect(() => {
    onItemChange({
      componentName: BUTTON_W_ICON,
      config: {
        titleH2: h2Title,
        backgroundColor: backgroundColor,
        button: slidesList,
      },
    });
  }, [backgroundColor, slidesList, h2Title]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === BUTTON_W_ICON,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError?.slides?.map((o) => o.pos),
        );
        setActiveTabIndex(sliderNdx);
        setActiveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const onColorChange = (color) => {
    setBackgroundColor(color);
  };
  const onTabChange = (e, value) => {
    setActiveTabIndex(value);
    setActiveTabContent(slidesList[value]);
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.push(addNewButton);
      setSlidesList(tempSlidesList);
      setActiveTabIndex(tempSlidesList.length - 1);
      setActiveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActiveTabIndex(tempSlidesList.length - 1);
        setActiveTabContent(tempSlidesList[tempSlidesList.length - 1]);
      } else {
        setActiveTabContent(tempSlidesList[activeTabIndex]);
      }
    }
  };

  const handleTabData = (val, slideContent, field) => {
    const isIconField = field === 'leftIconImgURL' || field === 'rightIconImgURL';
    if (isIconField && val === null) {
      setError((curr) => ({
        ...curr,
        slides: (curr?.slides || slidesList?.map((_, i) => ({ pos: i })))?.map((errItem) =>
          errItem?.pos === activeTabIndex ? { ...errItem, [field]: '' } : errItem,
        ),
      }));
    } else {
      const thisErr = setErrorField(field, val);
      setError((curr) => ({
        ...curr,
        slides: (curr?.slides || slidesList?.map((_, i) => ({ pos: i })))?.map((errItem) =>
          errItem?.pos === activeTabIndex ? { ...errItem, [field]: thisErr } : errItem,
        ),
      }));
    }
    switch (field) {
      case 'buttonTitle':
        slideContent.buttonTitle = val;
        break;
      case 'leftIconImgURL':
        slideContent.leftIconImgURL = val;
        break;
      case 'rightIconImgURL':
        slideContent.rightIconImgURL = val;
        break;
      case 'leftIconHide':
        slideContent.leftIconHide = val;
        break;
      case 'rightIconHide':
        slideContent.rightIconHide = val;
        break;
      case 'isActive':
        slideContent.redirectLink[0].isActive = val;
        break;
      case 'redirect':
        slideContent.redirectLink[0].connection = val.type;
        slideContent.redirectLink[0].linkId = val.value;
        slideContent.redirectLink[0].flowSubSelection = val.flowSubSelection;
        break;
      default:
        break;
    }
    setSlidesList((prevSlidesList) => {
      return prevSlidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return {
            ...slide,
            [field]: val,
          };
        } else {
          return slide;
        }
      });
    });
  };

  const onChangeH1 = (e) => {
    const raw = e;
    const err = setErrorField('titleH2', raw);
    setError((curr) => ({
      ...curr,
      config: { ...(curr?.config || {}), titleH2: err },
    }));

    setH2Title(raw);
  };

  const hasError = (key) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) => errorSlider.pos === activeTabIndex && errorSlider[key] === 'required',
    );
    if (hasSliderError) return true;
    return false;
  };

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed?.length > 0 ? '' : 'required';
    }

    if (val?.type) return '';
    return 'required';
  };

  return (
    <>
      <div className='row my-2 mx-4'>
        <div className='col-md-10 mt-4'>
          <CustomUiBuilderTextField
            label='H2 Title'
            required={true}
            className='col-md-12'
            value={h2Title}
            onChangeInput={(e) => onChangeH1(e.target.value)}
            maxLength={30}
            isAdornment={true}
            endAdornment={true}
            error={error?.config?.titleH2 === 'required' ? true : false}
          />
        </div>
        <div className='col-md-10 mt-4'>
          <div className='col-md-12 background-color-titleH2 mb-2'>Button Background</div>
          <div
            className='color-preview d-flex justify-content-center align-items-center shadow mb-4'
            style={{ backgroundColor: backgroundColor }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          >
            <span className='color-preview-label'>{backgroundColor}</span>
          </div>
        </div>
        <div className='row mt-4 mb-3'>
          <div className='col-md-12 slide-tabs d-flex'>
            <Tabs
              value={activeTabIndex}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={onTabChange}
              aria-label='tabs'
              textColor='primary'
              className='tabs'
            >
              {slidesList.map((slide, index) => (
                <Tab key={index} label={`Button ${index + 1}`} />
              ))}
            </Tabs>
            <div className='ms-2'>
              <Button
                disabled={slidesList.length >= maxSlidesCount}
                variant='outlined'
                size='medium'
                color='secondary'
                onClick={(e) => AddNewSlide(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
        </div>
        <div className='col-md-12 mt-3'>
          <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
            <div>Button {activeTabIndex + 1}</div>
            <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
              Remove
            </div>
          </div>
        </div>
        <div className='col-md-12 mt-2'>
          <CustomUiBuilderTextField
            label='Button Title'
            required={true}
            className='col-md-12'
            value={activeTabContent.buttonTitle}
            onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'buttonTitle')}
            maxLength={30}
            isAdornment={true}
            endAdornment={true}
            error={hasError('buttonTitle')}
          />
        </div>
        <div className='col-md-12 mt-4'>
          <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
            <div>Left Icon</div>
            <div
              className='text-underlined pointer'
              onClick={(e) => {
                handleTabData(!activeTabContent.leftIconHide, activeTabContent, 'leftIconHide');
              }}
            >
              {!activeTabContent?.leftIconHide ? 'Hide' : 'Show'}
            </div>
          </div>
        </div>
        {!activeTabContent?.leftIconHide && (
          <div className='mt-4'>
            <ImagePicker
              key={`btn-left-icon-${activeTabIndex}`}
              groupId={groupId}
              title={'Icon'}
              ratio={'1:1'}
              height={24}
              width={24}
              matrix={'px'}
              onImageSelect={(e) => handleTabData(e, activeTabContent, 'leftIconImgURL')}
              imgURL={activeTabContent.leftIconImgURL}
              error={hasError('leftIconImgURL')}
            />
          </div>
        )}
        <div className='col-md-12 mt-4'>
          <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
            <div>Right Icon</div>
            <div
              className='text-underlined pointer'
              onClick={(e) => {
                handleTabData(!activeTabContent.rightIconHide, activeTabContent, 'rightIconHide');
              }}
            >
              {!activeTabContent?.rightIconHide ? 'Hide' : 'Show'}
            </div>
          </div>
        </div>
        {!activeTabContent?.rightIconHide && (
          <div className='mt-4'>
            <ImagePicker
              key={`btn-right-icon-${activeTabIndex}`}
              groupId={groupId}
              title={'Icon'}
              ratio={'1:1'}
              height={24}
              width={24}
              matrix={'px'}
              onImageSelect={(e) => handleTabData(e, activeTabContent, 'rightIconImgURL')}
              imgURL={activeTabContent.rightIconImgURL}
              error={hasError('rightIconImgURL')}
            />
          </div>
        )}
        <div className='col-md-12 mt-4'>
          <RedirectSelector
            areButtonsDisabled={true}
            onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
            redirectType={activeTabContent.redirectLink[0].connection}
            value={activeTabContent.redirectLink[0].linkId}
            onRedirectChange={(e) => {
              handleTabData(e, activeTabContent, 'isActive');
            }}
            isActive={activeTabContent.redirectLink[0].isActive}
            error={hasError('redirect')}
            showFlowSubSelection={true}
            flowSubSelection={activeTabContent.redirectLink[0].flowSubSelection}
          />
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={backgroundColor}
          onColorChange={onColorChange}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default ButtonWithIcon;
